import { render, staticRenderFns } from "./BasketTotal.vue?vue&type=template&id=7c7409e1&scoped=true&"
import script from "./BasketTotal.vue?vue&type=script&lang=js&"
export * from "./BasketTotal.vue?vue&type=script&lang=js&"
import style0 from "./BasketTotal.vue?vue&type=style&index=0&id=7c7409e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7409e1",
  null
  
)

component.options.__file = "BasketTotal.vue"
export default component.exports